"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ChatOff = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_ChatOff_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.376.503A2.795 2.795 0 0 0 13.25.5H2.75A2.75 2.75 0 0 0 0 3.25v6.002c0 1.252.839 2.31 1.985 2.642l.887-.887a1.284 1.284 0 0 0-.122-.005A1.75 1.75 0 0 1 1 9.252V3.25c0-.966.784-1.75 1.75-1.75h9.629l.997-.997Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m.14 15.154 14.3-14.3a.505.505 0 0 0 .05-.06l.005.004.651-.652a.5.5 0 0 1 .708.708l-.559.558A2.74 2.74 0 0 1 16 3.25v6.002a2.75 2.75 0 0 1-2.75 2.75H8.49a2.5 2.5 0 0 0-1.767.732l-2.87 2.87A.5.5 0 0 1 3 15.25v-1.543L.854 15.854a.5.5 0 0 1-.715-.7ZM14.585 2.12 4 12.707v1.336l2.016-2.016a3.501 3.501 0 0 1 2.475-1.025h4.759A1.75 1.75 0 0 0 15 9.252V3.25c0-.43-.156-.824-.414-1.13Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_ChatOff_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = ChatOff;
exports["default"] = _default;